import { render, staticRenderFns } from "./CompositeCustomerForm.vue?vue&type=template&id=cf4257f6&"
import script from "./CompositeCustomerForm.vue?vue&type=script&lang=js&"
export * from "./CompositeCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports